import { namePattern } from "../../const/regexPatterns";

export function validateName({
  name,
  maxLength = 70,
  fieldName = "Name",
  required = true
}: {
  name: string;
  maxLength?: number;
  fieldName?: string;
  required?: boolean;
}) {
  if (!name) {
    if (required) return `${fieldName} is required.`;
    return undefined;
  }
  if (name.length > maxLength) {
    return `${fieldName} must not exceed ${maxLength} characters.`;
  }
  if (!namePattern.test(name))
    return `Invalid ${fieldName} (must only contain letters, spaces, apostrophes and hyphens).`;
}
